const MAX_TOTAL_QTY = 48;

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getLocaleMessage() {
        const lang = document.documentElement.lang || 'en';
        if (lang.startsWith('fr')) return `Vous avez atteint la limite de ${MAX_TOTAL_QTY} articles par panier.`;
        else return `You can only have ${MAX_TOTAL_QTY} items in your cart.`;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        config.body = formData;

        try {
          const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
          const current = cart?.item_count || 0;

          const qtyToAdd = parseInt(formData.get('quantity') || '1', 10) || 1;

          if (current + qtyToAdd > MAX_TOTAL_QTY) {
            const message = this.getLocaleMessage();

            this.handleErrorMessage(message);

            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              message,
            });

            this.error = true;
            return;
          }

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner')?.classList.remove('hidden');

          const response = await fetch(`${routes.cart_add_url}`, config).then((r) => r.json());

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span')?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
          }

          this.handleNotification(response);
          this.handleCartUpdate();
        } catch (e) {
          console.error(e);
        } finally {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
        }
      }

      handleNotification(response) {
        const notification = document.getElementById('cart_notification');
        const notificationContent = document.getElementById('cart_notification-content');
        const notificationClose = document.getElementById('cart_notification-close');

        const closeNotification = () => notification.classList.add('is-hidden');
        notificationClose.addEventListener('click', closeNotification);

        const image = document.createElement('img');
        image.src = response.image;
        notificationContent.appendChild(image);

        const text = document.createElement('div');
        text.classList.add('f', 'fc', 'gap-xs');

        const title = document.createElement('p');
        title.classList.add('h5', 'ttu', 'white');
        title.innerHTML = response.product_title;
        text.appendChild(title);

        const type = document.createElement('p');
        type.classList.add('label', 'ttu', 'light-green');
        type.innerHTML = response.product_type;
        text.appendChild(type);

        const price = document.createElement('p');
        price.classList.add('white');
        price.innerHTML = `${response.price / 100}€`;
        text.appendChild(price);

        notificationContent.appendChild(text);

        setTimeout(() => {
          notification.classList.remove('is-hidden');
          setTimeout(() => {
            notification.classList.add('is-hidden');
            setTimeout(() => {
              notificationContent.innerHTML = '';
              notificationClose.removeEventListener('click', closeNotification);
            }, 1000);
          }, 5000);
        }, 1000);
      }

      handleCartUpdate() {
        fetch(window.Shopify.routes.root + 'cart.js')
          .then((response) => response.json())
          .then((response) => {
            const count = document.getElementById('header_cart_count');
            const notificationCount = document.getElementById('cart_notification-count');
            const countWrapper = document.getElementById('header_cart_count_wrapper');
            count.innerHTML = response.item_count;
            notificationCount.innerHTML = ` (${response.item_count})`;
            countWrapper.classList.remove('hidden');
            const checkoutButton = document.getElementById('cart_notification-checkout');
            checkoutButton.href = `/checkouts/cn/${response.token}`;
          });
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        clearTimeout(this._errorTimeout);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;

          this._errorTimeout = setTimeout(() => {
            this.errorMessageWrapper.setAttribute('hidden', true);
            this.errorMessage.textContent = '';
          }, 7000);
        } else {
          this.errorMessage.textContent = '';
        }
      }
    }
  );
}
